import Transfer from './src/index.vue'

import type { App } from 'vue'
import type { SFCWithInstall } from '@sgui-plus/utils/types'

Transfer.install = (app: App): void => {
  app.component(Transfer.name, Transfer)
}

const _Transfer = Transfer as SFCWithInstall<typeof Transfer>

export default _Transfer
export const SgTransfer = _Transfer

export * from './src/transfer'
